module.exports = __webpack_public_path__ + "static/media/kolay-kullanim.c1879f63.png";